import React from 'react';
import Typography from '@mui/material/Typography';
import { Container, List, ListItem } from '@mui/material';

// Internal
import AppAppBar from './views/AppAppBar';
import AppFooter from './views/AppFooter';
import withRoot from '../../withRoot';

// The theme sizes h2/h4 in fixed px, so each heading scales itself down for narrow screens.
const headingSx = {
  fontSize: { xs: '1.75rem', sm: '2.25rem', md: '3rem' },
  lineHeight: 1.2,
  mt: { xs: 4, md: 6 },
};

const subheadingSx = {
  fontSize: { xs: '1.25rem', sm: '1.5rem', md: '2.25rem' },
  lineHeight: 1.3,
  mt: { xs: 3, md: 5 },
};

const bodySx = {
  fontSize: { xs: '1rem', md: '1.1rem' },
  lineHeight: 1.8,
};

const Guidelines = () => {
  return (
    <React.Fragment>
      <AppAppBar />
      <Container
        maxWidth="md"
        sx={{
          px: { xs: 2, sm: 3, md: 4 },
          py: { xs: 4, md: 6 },
        }}
      >
        <Typography variant="h2" gutterBottom sx={{ ...headingSx, mt: 0 }}>
          Community Guidelines
        </Typography>

        <Typography variant="body1" gutterBottom sx={bodySx}>
          Ink Bowl is a platform that encourages freedom of speech and candid
          self-expression. However, as a community of diverse creators with a broad
          audience, we insist that certain publication guidelines must be met to
          maintain a safe, inclusive, and respectful environment. Any work that
          jeopardizes the integrity of the platform will be irrefutably rejected. Be
          mindful of the Community Guidelines below as you draft your application.
        </Typography>

        <Typography variant="h4" gutterBottom sx={subheadingSx}>
          Use of Language
        </Typography>

        <Typography variant="body1" gutterBottom sx={bodySx}>
          Appropriate use of language is decided by the Ink Bowl Publishing Team on a
          case-by-case basis. However, content that includes the following will not be
          accepted: Gratuitous usage of profanity and crude remarks; slurs targeting any
          group of people (racial, ethnic, etc.)
        </Typography>

        <Typography variant="h4" gutterBottom sx={subheadingSx}>
          Content
        </Typography>

        <Typography variant="body1" gutterBottom sx={bodySx}>
          Ink Bowl does not condone and will reject any content containing the elements
          listed below:
        </Typography>
        <List sx={{ listStyleType: 'disc', pl: { xs: 3, md: 4 }, py: 0 }}>
          {[
            'Hate speech and unwarranted malice',
            'Expressing the support of racism, homophobia, transphobia, ableism, sexism, etc.',
            'Explicit, pornographic material',
            'This does not pertain to art or literature illustrating the beauty of the human body',
          ].map((entry) => (
            <ListItem
              key={entry}
              sx={{ display: 'list-item', px: 0, py: 0.5, ...bodySx }}
            >
              {entry}
            </ListItem>
          ))}
        </List>

        <Typography variant="h4" gutterBottom sx={subheadingSx}>
          Trigger Warnings
        </Typography>

        <Typography variant="body1" gutterBottom sx={bodySx}>
          Part of our policy to ensure the safety and well-being of Ink Bowl community
          members is to provide a disclaimer when published content has the potential to
          be upsetting to others. When submitting an application, we ask that you
          identify any prospective triggers.
        </Typography>
        <List sx={{ listStyleType: 'disc', pl: { xs: 3, md: 4 }, py: 0 }}>
          {[
            'Sexual Violence (rape, assault)',
            'Violence (broadly, graphic images or descriptions)',
            'Eating Disorders',
            'Abuse (emotional, physical)',
            'Suicide',
            'Mental Health Disorders',
            'Substance Abuse',
          ].map((entry) => (
            <ListItem
              key={entry}
              sx={{ display: 'list-item', px: 0, py: 0.5, ...bodySx }}
            >
              {entry}
            </ListItem>
          ))}
        </List>
      </Container>

      <AppFooter />
    </React.Fragment>
  );
};

export default withRoot(Guidelines);
